/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var T,S;!function(T){T[T.INSIDE=0]="INSIDE",T[T.INTERSECTS=1]="INTERSECTS",T[T.OUTSIDE=2]="OUTSIDE"}(T||(T={})),function(T){T[T.NORTH=0]="NORTH",T[T.NORTH_EAST=1]="NORTH_EAST",T[T.EAST=2]="EAST",T[T.SOUTH_EAST=3]="SOUTH_EAST",T[T.SOUTH=4]="SOUTH",T[T.SOUTH_WEST=5]="SOUTH_WEST",T[T.WEST=6]="WEST",T[T.NORTH_WEST=7]="NORTH_WEST"}(S||(S={}));export{S as NeighborIndex,T as TileFrustumVisibility};
